import { useEffect } from "react";

/** Escape closes, arrows page, space toggles selection. */
export const useLightboxKeys = ({ photo, onClose, onPrev, onNext, onToggleSelect }) => {
  useEffect(() => {
    if (!photo) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft" && onPrev) onPrev();
      if (e.key === "ArrowRight" && onNext) onNext();
      if (e.key === " " && onToggleSelect) {
        e.preventDefault();
        onToggleSelect(photo.file_id);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [photo, onClose, onPrev, onNext, onToggleSelect]);
};
